import globalStylesPackage from '@marriott/global-styles/package.json';

interface GlobalStylesOptions {
  assetUrl?: string;
  isProd?: boolean;
  rtl?: boolean;
  deployedEnvType?: string;
}

export function getGlobalStyles({
  assetUrl,
  isProd = false,
  rtl = false,
  deployedEnvType = process.env['DEPLOYED_ENV_TYPE'] || '',
}: GlobalStylesOptions): string {
  const version = globalStylesPackage.version;

  // Use fallback when assetUrl is missing, null, undefined, or empty string
  const resolvedAssetUrl = assetUrl && assetUrl.trim() ? assetUrl : 'https://www.marriott.com';
  // normalize trailing slash
  const base = resolvedAssetUrl.endsWith('/') ? resolvedAssetUrl : `${resolvedAssetUrl}/`;

  // Only use .min.css when truly in production
  const useMinified = isProd && deployedEnvType.toLowerCase() === 'higher';

  const suffix = rtl ? '.rtl' : '';
  const min = useMinified ? '.min' : '';

  // TODO: fix typo to 'marriott' when CSS file is renamed
  const filename = `marriot.global${suffix}${min}.css`;

  return `${base}global-styles/${version}/${filename}`;
}
